export const updatequantityreq="updatequatityreq"
export const updatequantitysucc="updatequantitysucc"
export const updatequantityfail="updatequantityfail"
